import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Loader } from '@googlemaps/js-api-loader';
import { from, Observable } from 'rxjs';

import { environment } from '~environments/environment';

@Injectable()
export class MapService {
  http = inject(HttpClient);
  loader = new Loader({
    apiKey: environment.googleMapAccessToken,
    version: 'weekly'
  });

  getMapLibrary(): Observable<google.maps.MapsLibrary> {
    return from(this.loader.importLibrary('maps'));
  }

  getGeocodingLibrary(): Observable<google.maps.GeocodingLibrary> {
    return from(this.loader.importLibrary('geocoding'));
  }

  getPlacesLibrary(): Observable<google.maps.PlacesLibrary> {
    return from(this.loader.importLibrary('places'));
  }

  getMarkerLibrary(): Observable<google.maps.MarkerLibrary> {
    return from(this.loader.importLibrary('marker'));
  }
}
